<template>
  <AppLayout>
    <div class="add-tender-page">
      <div class="add-tender-content" :class="{ 'add-tender-content--loading': pageLoading }">
      <section>
        <div class="">
        <!-- Tender Form Section -->
        <div class="filter-search" style="margin-top: 0px;padding-left: 0px;">
          <div class="filter-search-body">
            <form @submit.prevent="submitTender" class="form">
              
              <!-- Header: Title + Publish button aligned horizontally -->
              <div class="tender-header-row">
                <h5 class="fw-bold mb-0">{{ isEditMode ? 'Edit Tender' : 'Add Supply Tender' }}{{ !isEditMode && purchaseRequestNo ? ` for Purchase Request ${purchaseRequestNo}` : '' }}</h5>
                <button
                  type="button"
                  style="text-transform: capitalize !important; font-size: 10px !important;"
                  class="btn btn-primary publish-btn"
                  :disabled="loading"
                  @click="submitTender"
                  title="Publish Tender"
                  aria-label="Publish Tender"
                >
                 
                  <i class="fas fa-spinner fa-spin" v-if="loading"></i>
                  <span style="margin-left:11px">{{ loading ? 'Publishing...' : 'Publish Tender' }}</span>
                </button>
              </div>

                <!-- If no purchase request linked, allow adding tender items manually -->
                <div v-if="showTenderItems && !selectedPurchaseRequestDetails" class="row" style="margin-top:10px;">
                  <div class="col-md-12">
                    <div class="card" style="padding:11px;border:1px solid #e9ecef;border-radius:6px;background:#fff;">
                      <div style="margin-bottom:8px;display:flex;justify-content:space-between;align-items:center;">
                        <p class="fw-bold">Tender Items</p>
                        <button type="button" class="btn btn-sm btn-primary" @click.prevent="addItem">Add Item</button>
                      </div>
                      <table class="table table-sm">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Description</th>
                            <th>Qty</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(it, idx) in formItems" :key="idx">
                            <td>{{ idx + 1 }}</td>
                            <td>
                              <select class="form-control" v-model="it.productId" @change="onProductSelect(idx)">
                                <option value="">-- Select Product --</option>
                                <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }}{{ p.code ? (' — ' + p.code) : '' }}</option>
                              </select>
                            </td>
                            <td><input type="number" class="form-control" v-model.number="it.quantity" @input="updateItemTotal(idx)" min="0" /></td>
                            <td><input type="number" class="form-control" v-model.number="it.unitPrice" @input="updateItemTotal(idx)" step="0.01" /></td>
                            <td>{{ it.totalPrice || 0 }}</td>
                            <td><button class="btn btn-sm btn-danger" type="button" @click.prevent="removeItem(idx)">Remove</button></td>
                          </tr>
                          <tr v-if="formItems.length === 0"><td colspan="6" class="text-center">No items added</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="linkedPurchaseRequest">Purchase Request *</label>
                    <select class="form-control" v-model="selectedPurchaseRequestId">
                      <option value="">None</option>
                      <option v-for="pr in processingPurchaseRequests" :key="pr.id" :value="pr.id">
                        {{ pr.purchaseRequestNo || pr.requestNumber || ('PR' + pr.id) }} - {{ pr.requesterUser?.name || pr.requestedBy?.name || '' }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="referenceNumber">Reference Number *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="form.referenceNumber" 
                      required
                      placeholder="e.g., TNR-2024-001"
                    />
                  </div>
                </div>
                <!-- :disabled="categoryLocked"  -->
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="category">Category *</label>
                    <select class="form-control" v-model="form.category"  required>
                      <option value="">Select Category</option>
                      <option v-for="category in tenderCategories" :key="category.id" :value="category.name">
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>
                
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="title">Tender Title *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="form.title" 
                      required
                      @input="generateSlug"
                      placeholder="Enter descriptive tender title"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                  <div class="form-group">
                    <label for="required-docs">Required Supplier Documents</label>
                    <multiselect v-model="selectedRequiredDocumentObjects"
                      :options="supplierDocumentTypes"
                      :multiple="true"
                      track-by="id"
                      label="name"
                      placeholder="Select required documents"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="prequalifiedSuppliers">Prequalified Suppliers</label>
                    <multiselect v-model="selectedSuppliers"
                      :options="prequalifiedSuppliers"
                      :multiple="true"
                      track-by="id"
                      label="displayLabel"
                      placeholder="Auto-selected prequalified suppliers"
                      :disabled="true"
                      class="form-control"
                    />
                    <div class="supplier-list" style="margin-top:10px;">
                      <div style="display:flex;justify-content:space-between;align-items:center;">
                        <!--<label class="text-muted" v-if="prequalifiedSuppliers.length > 0">All prequalified suppliers</label>-->
                        <button type="button" class="btn btn-sm btn-supplier-toggle" @click="toggleSupplierList" v-if="prequalifiedSuppliers.length > 0">
                          {{ showSupplierList ? 'Hide' : 'Show All Prequalified Suppliers' }}
                        </button>
                      </div>
                      <ul v-show="showSupplierList" style="list-style:none;padding-left:0;margin-top:8px;max-height:180px;overflow:auto;">
                        <li v-for="sup in sortedPrequalifiedSuppliers" :key="sup.id" style="display:flex;justify-content:space-between;align-items:center;padding:6px 8px;border-bottom:1px solid #f1f1f1;">
                          <div>
                            <p style="font-size:15px;" class="fw-bold">{{ sup.name }}</p>
                              <div style="font-size:11px;color:#666">{{ getSupplierCategories(sup) }}</div>
                          </div>
                          <div>
                            <span v-if="selectedSuppliers.find(s => s.id === sup.id)" class="badge badge-success">Selected</span>
                          </div>
                        </li>
                        <!--
                        <li v-if="prequalifiedSuppliers.length === 0" class="text-muted p-2">No prequalified suppliers found</li> 
                        -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>


                </div>
                

              <!--
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="slug">URL Slug *</label>
                    <input 
                      type="text" 
                      class="form-control" 
                      v-model="form.slug" 
                      required
                      pattern="[a-z0-9\-]+"
                      placeholder="auto-generated-from-title"
                    />
                    <small class="text-muted">Only lowercase letters, numbers, and hyphens allowed</small>
                  </div>
                </div>
              </div>
              -->

              <!-- If a purchase request is linked/selected, show its items -->
              <div v-if="selectedPurchaseRequestDetails" class="row" style="margin-top:10px;">
                <div class="col-md-12">
                  <div class="card" style="padding:11px;border:1px solid #e9ecef;background:#fff;">
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Item</th>
                          <th>Code</th>
                          <th>Unit</th>
                          <th>Requested</th>
                          <th>Processed</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(it, idx) in selectedPurchaseRequestDetails.items" :key="it.id">
                          <td>{{ idx + 1 }}</td>
                          <td>{{ it.product?.name || it.service?.name || it.name || '' }}</td>
                          <td>{{ it.product?.code || it.service?.code || it.productCode || '—' }}</td>
                          <td>{{ it.unit || it.product?.unit?.unit || it.service?.unit?.name || it.uom || '' }}</td>
                          <td>{{ it.quantity ?? 0 }}</td>
                          <td>{{ it.processedQuantity ?? it.quantityProcessed ?? 0 }}</td>
                        </tr>
                        <tr v-if="!selectedPurchaseRequestDetails.items || selectedPurchaseRequestDetails.items.length === 0"><td colspan="6" class="text-center">No items</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row mt-3"  v-if="prequalifiedSuppliers.length != 0">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="description">Description *</label>
                    <textarea 
                      class="form-control" 
                      v-model="form.description" 
                      required
                      rows="2"
                      placeholder="Provide a comprehensive description of the tender"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Timeline Section -->
              <div class="form-section-header">
                <h6>Timeline & Dates</h6>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="publishDate">Publish Date *</label>
                    <input 
                      type="datetime-local" 
                      class="form-control" 
                      v-model="form.publishDate" 
                      required
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="submissionDeadline">Submission Deadline *</label>
                    <input 
                      type="datetime-local" 
                      class="form-control" 
                      v-model="form.submissionDeadline" 
                      required
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="openingDate">Opening Date</label>
                    <input 
                      type="datetime-local" 
                      class="form-control" 
                      v-model="form.openingDate"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="evaluationPeriod">Evaluation Period (Days)</label>
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model.number="form.evaluationPeriod"
                      min="1"
                      placeholder="e.g., 30"
                    />
                  </div>
                </div>
              </div>

              <!-- Financial Information -->
              <div class="form-section-header mt-4">
                <h6>Financial Information</h6>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="estimatedValue">Estimated Value</label>
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model.number="form.estimatedValue"
                      min="0"
                      step="0.01"
                      placeholder="0.00"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="currency">Currency</label>
                    <select class="form-control" v-model="form.currency">
                      <option value="USD">USD - US Dollar</option>
                      <option value="EUR">EUR - Euro</option>
                      <option value="GBP">GBP - British Pound</option>
                      <option value="KES">KES - Kenyan Shilling</option>
                      <option value="UGX">UGX - Ugandan Shilling</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="bondRequired">Performance Bond (%)</label>
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model.number="form.bondRequired"
                      min="0"
                      max="100"
                      step="0.1"
                      placeholder="e.g., 10"
                    />
                  </div>
                </div>
              </div>

              <!-- Detailed Requirements -->
              <div class="form-section-header mt-5">
                <h6>Requirements & Specifications</h6>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="objectives">Objectives</label>
                    <textarea 
                      class="form-control" 
                      v-model="form.objectives" 
                      rows="2"
                      placeholder="Describe the main objectives and goals"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="scope">Scope of Work</label>
                    <textarea 
                      class="form-control" 
                      v-model="form.scope" 
                      rows="2"
                      placeholder="Define the scope and boundaries of the work"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="eligibilityCriteria">Eligibility Criteria</label>
                    <textarea 
                      class="form-control" 
                      v-model="form.eligibilityCriteria" 
                      rows="2"
                      placeholder="Specify eligibility requirements for applicants"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="technicalRequirements">Technical Requirements</label>
                    <textarea 
                      class="form-control" 
                      v-model="form.technicalRequirements" 
                      rows="2"
                      placeholder="Detail technical specifications and requirements"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Evaluation Criteria -->
              <div class="form-section-header">
                <h6>Evaluation Criteria</h6>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="evaluationCriteria">Evaluation Criteria</label>
                    <textarea 
                      class="form-control" 
                      v-model="form.evaluationCriteria" 
                      rows="2"
                      placeholder="Specify how applications will be evaluated"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Form Actions -->
              <div class="form-actions" style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #dee2e6;">
                <div class="row">
                  <div class="col-md-12 text-right">
                    <!--<button 
                      type="button" 
                      @click="goBack" 
                      class="btn btn-secondary" 
                      style="margin-right: 10px;"
                      :disabled="loading"
                    >
                      <i class="fas fa-arrow-left"></i> Back to List
                    </button>
                    <button 
                      type="button" 
                      @click="saveDraft" 
                      class="btn btn-warning" 
                      style="margin-right: 10px;"
                      :disabled="loading"
                    >
                      <i class="fas fa-save"></i> Save as Draft
                    </button>
                    <button 
                      type="submit" 
                      class="btn btn-primary" 
                      :disabled="loading"
                    >
                      <i class="fas fa-check" v-if="!loading"></i>
                      <i class="fas fa-spinner fa-spin" v-if="loading"></i>
                      {{ loading ? 'Publishing...' : 'Publish Tender' }}
                    </button>-->
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>

      </div>
    </section>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/components/AppLayout.vue'
import { tenderApi } from '@/api/tender'
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AddTender',
  components: {
    AppLayout
  ,
  Multiselect
  },
  computed: {
    ...mapGetters(['getTenderCategories', 'getProducts']),
    isEditMode() {
      return this.$route.name === 'EditTender' && this.$route.params?.id
    },
    editingTenderId() {
      return this.isEditMode ? this.$route.params.id : null
    },
    tenderCategories() {
      return this.getTenderCategories
    },
    sortedPrequalifiedSuppliers() {
      const selected = this.selectedSuppliers || []
      const list = [...(this.prequalifiedSuppliers || [])]
      return list.sort((a, b) => {
        const aSelected = selected.some(s => (s.id || s) === (a.id || a))
        const bSelected = selected.some(s => (s.id || s) === (b.id || b))
        if (aSelected && !bSelected) return -1
        if (!aSelected && bSelected) return 1
        return 0
      })
    }
  },
  data() {
    return {
      // available products for selection in tender items
      products: [],
      loading: false,
      pageLoading: true,
      purchaseRequestNo: '',
      form: {
        referenceNumber: '',
        title: '',
        slug: '',
        description: '',
        category: '',
        publishDate: '',
        submissionDeadline: '',
        openingDate: '',
        evaluationPeriod: 30,
        estimatedValue: null,
        currency: 'KES',
        bondRequired: null,
        objectives: '',
        scope: '',
        eligibilityCriteria: '',
        technicalRequirements: '',
        evaluationCriteria: '',
        contactPerson: '',
        requiredSupplierDocumentIds: [],
        contactEmail: '',
        contactPhone: ''
      },
      processingPurchaseRequests: [],
      selectedPurchaseRequestId: null,
      selectedPurchaseRequestDetails: null,
      supplierDocumentTypes: [],
      selectedRequiredDocumentObjects: [],
      // New: prequalified suppliers multiselect
      prequalifiedSuppliers: [],
      selectedSuppliers: [],
      // items for tenders not linked to a purchase request
      formItems: [],
      // toggle display of tender items (hidden by default)
      showTenderItems: false,
      categoryLocked: false
      ,
      showSupplierList: false
    }
  },
  async mounted() {
    this.setDefaultDates()
    try {
      const prId = this.$route.query.purchaseRequestId
      const tenderId = this.editingTenderId
      await Promise.all([
        this.fetchSupplierDocumentTypes(),
        this.fetchTenderCategories(),
        this.fetchProducts(),
        this.fetchProcessingPurchaseRequests()
      ])
      if (prId) await this.prefillFromPurchaseRequest(prId)
      if (tenderId) await this.prefillFromTender(tenderId)
    } catch (e) {
      console.error('Failed to load add tender data', e)
    } finally {
      this.products = this.getProducts || []
      this.pageLoading = false
    }
  },
  watch: {
    'selectedRequiredDocumentObjects'(newVal) {
      if (!newVal) return;
      const mandatoryDocs = this.supplierDocumentTypes.filter(dt => dt.isMandatory);
      if (mandatoryDocs.length > 0) {
        const existingIds = newVal.map(d => d.id);
        let missing = false;
        mandatoryDocs.forEach(md => {
          if (!existingIds.includes(md.id)) {
            missing = true;
            newVal.push(md);
          }
        });
        if (missing) {
           Swal.fire({ text: 'Cannot remove a mandatory document type', icon: 'warning', toast: true, position: 'top-end', timer: 3000, showConfirmButton: false });
        }
      }
    },
    'form.category'(newVal) {
      if (!newVal) return
      // when category changes, refresh supplier list and auto-select matching suppliers
      this.fetchPrequalifiedSuppliers(newVal)
    }
    ,
    'selectedPurchaseRequestId'(newVal) {
      if (!newVal) {
        this.selectedPurchaseRequestDetails = null
        return
      }
      this.fetchPurchaseRequestDetails(newVal)
    }
  },
  methods: {
    ...mapActions(['fetchTenderCategories', 'fetchProducts']),
    inferCategoryFromPR(pr) {
      if (!pr) return null
      const tryResolve = (cand) => {
        if (cand == null) return null
        // primitive string
        if (typeof cand === 'string' && cand.trim()) return cand.trim()
        // object with name/title
        if (typeof cand === 'object') {
          if (cand.name) return cand.name
          if (cand.title) return cand.title
          if (cand.label) return cand.label
          if (typeof cand.id === 'number') {
            const found = (this.tenderCategories || []).find(c => Number(c.id) === Number(cand.id))
            if (found) return found.name
          }
        }
        // numeric id
        if (typeof cand === 'number' || (!isNaN(Number(cand)) && String(cand).trim() !== '')) {
          const id = Number(cand)
          const found = (this.tenderCategories || []).find(c => Number(c.id) === id)
          if (found) return found.name
        }
        return null
      }

      const keys = ['procurementCategory', 'category', 'tenderCategory', 'procurement_category', 'procurementCategoryId', 'tenderCategoryId']
      for (const k of keys) {
        const val = pr[k]
        const resolved = tryResolve(val)
        if (resolved) return resolved
      }
      return null
    },
    setDefaultDates() {
      const now = new Date()
      const tomorrow = new Date(now)
      tomorrow.setDate(tomorrow.getDate() + 1)
      
      const nextWeek = new Date(now)
      nextWeek.setDate(nextWeek.getDate() + 7)
      
      this.form.publishDate = this.formatDateForInput(tomorrow)
      this.form.submissionDeadline = this.formatDateForInput(nextWeek)
      this.form.openingDate = this.formatDateForInput(now)
    },

    formatDateForInput(date) {
      return date.toISOString().slice(0, 16)
    },

    generateSlug() {
      this.form.slug = this.form.title
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim()
    },

    clearForm() {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = ''
        } else if (typeof this.form[key] === 'number') {
          this.form[key] = key === 'evaluationPeriod' ? 30 : null
        }
      })
      this.form.currency = 'KES'
      this.setDefaultDates()
    },

    async saveDraft() {
      try {
        this.loading = true
        const tenderData = {
          ...this.form,
          status: 'DRAFT',
          purchaseRequestId: this.selectedPurchaseRequestId || undefined
        }
        
        await tenderApi. Tender(tenderData)
        
        Swal.fire({
          icon: 'success',
          title: 'Draft Saved',
          text: 'Tender saved as draft successfully'
        })
        
        this.clearForm()
        
      } catch (error) {
        console.error('Error saving draft:', error)
        const msg = this.getErrorMessage(error, 'Failed to save tender draft')
        Swal.fire({
          icon: 'error',
          title: 'Save Failed',
          text: msg,
          confirmButtonText: 'OK',
          confirmButtonColor: '#0d6efd',
        })
      } finally {
        this.loading = false
      }
    },

    async prefillFromPurchaseRequest(prId) {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch((process.env.VUE_APP_URL || '') + `/purchase-requests/${prId}`, {
          headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
        })
        if (!res.ok) return
        const data = await res.json()
        const pr = data && (data.data || data) ? (data.data || data) : null
        if (!pr) return
        // Prefill tender fields from purchase request
        // store purchase request number for the page title
        this.purchaseRequestNo = pr.purchaseRequestNo || (pr.id ? `PR${String(pr.id).padStart(6, '0')}` : '')
        // keep tender title empty — user must enter it
        this.form.title = ''
        this.form.description = pr.description || ''
        this.form.referenceNumber = `TND-${pr.purchaseRequestNo || pr.id || ''}`
        this.form.estimatedValue = pr.totalAmount || this.form.estimatedValue
        // auto-select this purchase request in the link select if possible
        if (pr.id) {
          this.selectedPurchaseRequestId = pr.id
          // ensure it's present in processingPurchaseRequests so the option is visible
          try {
            const exists = this.processingPurchaseRequests.find(p => p && p.id === pr.id)
            if (!exists) this.processingPurchaseRequests.unshift(pr)
          } catch (e) { /* ignore */ }
        }
        // Try to infer category from purchase request and lock it
        const inferredCategory = this.inferCategoryFromPR(pr)
        if (inferredCategory) {
          this.form.category = inferredCategory
          this.categoryLocked = true
          // fetch prequalified suppliers for that category
          this.fetchPrequalifiedSuppliers(inferredCategory)
        } else {
          // fallback: fetch prequalified suppliers without category
          this.fetchPrequalifiedSuppliers()
        }
        // store full details for listing items
        this.selectedPurchaseRequestDetails = pr
        // ensure selection in the optional link select
        // second guard already handled above
      } catch (error) {
        console.error('Error pre-filling tender from purchase request:', error)
      }
    },

    async prefillFromTender(tenderId) {
      try {
        const data = await tenderApi.getTender(tenderId)
        const t = data && (data.data || data) ? (data.data || data) : null
        if (!t) return
        this.form.referenceNumber = t.referenceNumber || ''
        this.form.title = t.title || ''
        this.form.slug = t.slug || ''
        this.form.description = t.description || ''
        this.form.category = (t.category && (t.category.name || t.category)) || t.category || ''
        this.form.publishDate = t.publishDate ? this.formatDateForInput(new Date(t.publishDate)) : ''
        this.form.submissionDeadline = t.submissionDeadline ? this.formatDateForInput(new Date(t.submissionDeadline)) : ''
        this.form.openingDate = t.openingDate ? this.formatDateForInput(new Date(t.openingDate)) : ''
        this.form.evaluationPeriod = t.evaluationPeriod ?? 30
        this.form.estimatedValue = t.estimatedValue != null ? Number(t.estimatedValue) : null
        this.form.currency = t.currency || 'KES'
        this.form.bondRequired = t.bondRequired != null ? Number(t.bondRequired) : null
        this.form.objectives = t.objectives || ''
        this.form.scope = t.scope || ''
        this.form.eligibilityCriteria = t.eligibilityCriteria || ''
        this.form.technicalRequirements = t.technicalRequirements || t.technicalSpec || ''
        this.form.evaluationCriteria = t.evaluationCriteria || ''
        this.form.contactPerson = t.contactPerson || ''
        this.form.contactEmail = t.contactEmail || ''
        this.form.contactPhone = t.contactPhone || ''
        if (t.purchaseRequestId) {
          this.selectedPurchaseRequestId = t.purchaseRequestId
          const pr = t.purchaseRequest || t.PurchaseRequest
          if (pr) {
            this.purchaseRequestNo = pr.purchaseRequestNo || ''
            this.selectedPurchaseRequestDetails = pr
            // Ensure linked PR appears in dropdown (it may not be in processing list if already completed)
            const exists = this.processingPurchaseRequests.some(p => p && p.id === pr.id)
            if (!exists) {
              const prForSelect = { ...pr, requesterUser: pr.requestedBy }
              this.processingPurchaseRequests.unshift(prForSelect)
            }
          }
        }
        const items = t.TenderItem || t.tenderItems || t.items || []
        if (items.length > 0) {
          this.showTenderItems = true
          this.formItems = items.map(i => ({
            description: (i.product && i.product.name) || i.description || '',
            quantity: i.quantity || 1,
            unitPrice: i.unitPrice != null ? Number(i.unitPrice) : null,
            totalPrice: i.totalPrice != null ? Number(i.totalPrice) : null,
            productId: (i.product && i.product.id) || i.productId || null,
            specifications: i.specifications || ''
          }))
          this.computeEstimatedFromFormItems()
        }
        const docIds = (t.requiredSupplierDocuments || []).map(d => d.supplierDocumentTypeId || d.id).filter(Boolean)
        if (docIds.length > 0) {
          this.selectedRequiredDocumentObjects = (this.supplierDocumentTypes || []).filter(dt => docIds.includes(dt.id))
        }
      } catch (err) {
        console.error('Error pre-filling tender for edit:', err)
        throw err
      }
    },

    async fetchPurchaseRequestDetails(id) {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch((process.env.VUE_APP_URL || '') + `/purchase-requests/${id}`, {
          headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
        })
        if (!res.ok) return
        const data = await res.json()
        const pr = data && (data.data || data) ? (data.data || data) : null
        if (!pr) return
        // normalize and assign
        pr.requestNumber = pr.purchaseRequestNo || pr.requestNumber
        pr.items = pr.items || []
        this.selectedPurchaseRequestDetails = pr
        // infer and autoselect category when user selects a purchase request
        const inferredCategory = this.inferCategoryFromPR(pr)
        if (inferredCategory) {
          this.form.category = inferredCategory
          this.categoryLocked = true
          this.fetchPrequalifiedSuppliers(inferredCategory)
        }
        // compute estimated value from purchase request items
        try {
          const est = (pr.items || []).reduce((sum, it) => {
            const q = Number(it.processedQuantity || it.quantity || 0) || 0
            const price = Number((it.product && it.product.pricePurchase) || it.unitPrice || 0) || 0
            return sum + q * price
          }, 0)
          if (est > 0) this.form.estimatedValue = est
        } catch (e) {
          // ignore
        }
      } catch (err) {
        console.error('Failed to load purchase request details', err)
      }
    },

    async fetchPrequalifiedSuppliers(category) {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch((process.env.VUE_APP_URL || '') + '/suppliers', { headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' } })
        if (!res.ok) return
        const data = await res.json()
        const suppliers = Array.isArray(data) ? data : (data.data || [])
        // normalize supplier entries and filter for prequalified status
        this.prequalifiedSuppliers = suppliers
          .filter(s => s.prequalified === true || (s.prequalified && String(s.prequalified) === 'true'))
          .map(s => {
            // try to infer procurement category from joined relation or fields
            const tc = (s.SupplierTenderCategory && Array.isArray(s.SupplierTenderCategory) && s.SupplierTenderCategory[0]?.tenderCategory)
            const catFromRelation = tc ? (tc.name || tc.title || '') : ''
            const cat = s.procurementCategory || s.procurement_category || s.category || catFromRelation || ''
            return { ...s, procurementCategory: cat, displayLabel: `${s.name}${cat ? ' — ' + cat : ''}` }
          })
          this.prequalifiedSuppliers = suppliers
            .filter(s => s.prequalified === true || (s.prequalified && String(s.prequalified) === 'true'))
            .map(s => {
              // gather categories from relation and possible fields
              const relCats = (s.SupplierTenderCategory && Array.isArray(s.SupplierTenderCategory))
                ? s.SupplierTenderCategory.map(sc => sc?.tenderCategory?.name).filter(Boolean)
                : []
              const fieldCats = []
              if (s.procurementCategory) fieldCats.push(s.procurementCategory)
              if (s.procurement_category) fieldCats.push(s.procurement_category)
              if (s.category) fieldCats.push(s.category)
              const allCats = Array.from(new Set([...relCats, ...fieldCats]))
              const primary = allCats[0] || ''
              return { ...s, procurementCategories: allCats, procurementCategory: primary, displayLabel: `${s.name}${primary ? ' — ' + primary : ''}` }
            })
        // auto-select suppliers matching current category
        if (category) {
            this.selectedSuppliers = this.prequalifiedSuppliers.filter(s => {
              const cats = s.procurementCategories || []
              return cats.includes(category) || (s.procurementCategory || '') === category
            })
        }
      } catch (err) {
        console.error('Failed to load prequalified suppliers', err)
      }
    },



    onProductSelect(idx) {
      const it = this.formItems[idx]
      if (!it) return
      const pid = it.productId
      if (!pid) return
      const prod = this.products.find(p => String(p.id) === String(pid) || Number(p.id) === Number(pid))
      if (!prod) return
      // populate description and unit price from product
      it.description = prod.name || it.description
      it.unitPrice = prod.pricePurchase || it.unitPrice || 0
      it.productId = prod.id
      this.updateItemTotal(idx)
    },

    addItem() {
      this.formItems.push({ description: '', quantity: 1, unitPrice: null, totalPrice: null, productId: null, specifications: '' });
      this.computeEstimatedFromFormItems()
    },

    removeItem(idx) {
      this.formItems.splice(idx, 1);
      this.computeEstimatedFromFormItems()
    },

    updateItemTotal(idx) {
      const it = this.formItems[idx];
      const q = Number(it.quantity) || 0;
      const p = Number(it.unitPrice) || 0;
      it.totalPrice = q * p;
      this.computeEstimatedFromFormItems()
    },

    computeEstimatedFromFormItems() {
      try {
        const est = (this.formItems || []).reduce((sum, it) => {
          const q = Number(it.quantity) || 0
          const price = Number(it.unitPrice) || (it.totalPrice && q ? Number(it.totalPrice) / q : 0) || 0
          return sum + q * price
        }, 0)
        this.form.estimatedValue = est || this.form.estimatedValue
      } catch (e) {
        // ignore
      }
    },

    getSupplierCategories(sup) {
      const cats = []
      if (sup.procurementCategory) cats.push(sup.procurementCategory)
      if (sup.procurement_category) cats.push(sup.procurement_category)
      if (sup.category) cats.push(sup.category)
      if (sup.procurementCategories && Array.isArray(sup.procurementCategories)) cats.push(...sup.procurementCategories)
      if (sup.SupplierTenderCategory && Array.isArray(sup.SupplierTenderCategory)) {
        sup.SupplierTenderCategory.forEach(sc => {
          if (sc?.tenderCategory?.name) cats.push(sc.tenderCategory.name)
        })
      }
      const uniq = Array.from(new Set(cats.filter(Boolean)))
      return uniq.join(', ')
    },

    toggleSupplierList() {
      this.showSupplierList = !this.showSupplierList
    },

    getErrorMessage(error, fallback = 'An error occurred') {
      if (!error) return fallback
      if (typeof error === 'string') return error
      const m = error.message ?? error.msg
      if (Array.isArray(m)) return m.join('. ')
      if (typeof m === 'string') return m
      const data = error.response?.data ?? error.data
      const dm = data?.message ?? data?.msg
      if (Array.isArray(dm)) return dm.join('. ')
      if (typeof dm === 'string') return dm
      return fallback
    },

    async submitTender() {
      try {
        this.loading = true
        
        // Validation
        if (new Date(this.form.submissionDeadline) <= new Date(this.form.publishDate)) {
          throw new Error('Submission deadline must be after publish date')
        }

        const tenderData = {
          ...this.form,
          status: 'PUBLISHED',
          purchaseRequestId: this.selectedPurchaseRequestId || undefined,
          requiredSupplierDocumentIds: this.selectedRequiredDocumentObjects.map(d => d.id),
          prequalifiedSupplierIds: this.selectedSuppliers.map(s => s.id || s)
          ,
          // include manual items when not linked to a purchase request
          items: this.selectedPurchaseRequestId ? undefined : (this.formItems.map(i => ({
            description: i.description,
            quantity: i.quantity,
            unitPrice: i.unitPrice,
            totalPrice: i.totalPrice,
            productId: i.productId,
            specifications: i.specifications,
          })) || []),
        }

        let response
        if (this.isEditMode && this.editingTenderId) {
          response = await tenderApi.updateTender(this.editingTenderId, tenderData)
        } else {
          response = await tenderApi.createTender(tenderData)
        }

        // If this tender was created (not edited) from a purchase request, mark that request as completed
        const prId = this.$route.query.purchaseRequestId
        if (!this.isEditMode && prId) {
          try {
            const token = JSON.parse(localStorage.getItem('access_token'))
            await fetch((process.env.VUE_APP_URL || '') + `/purchase-requests/${prId}/complete`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
              }
            })
          } catch (err) {
            console.error('Failed to mark purchase request as completed:', err)
          }
        }
        
        Swal.fire({
          icon: 'success',
          title: this.isEditMode ? 'Tender Updated' : 'Tender Published',
          text: this.isEditMode
            ? `Tender "${this.form.title}" has been updated successfully`
            : `Tender "${this.form.title}" has been published successfully`,
          showConfirmButton: true,
          confirmButtonText: 'View Tender'
        }).then((result) => {
          if (result.isConfirmed) {
            const tenderId = this.isEditMode ? this.editingTenderId : (response?.data?.id ?? response?.id)
            if (tenderId) {
              this.$router.push(`/admin/tenders/${tenderId}`)
            } else {
              this.goBack()
            }
          } else {
            this.goBack()
          }
        })
        
        if (!this.isEditMode) this.clearForm()
        
      } catch (error) {
        console.error('Error creating tender:', error)
        const msg = this.getErrorMessage(error, 'Failed to publish tender')
        Swal.fire({
          icon: 'error',
          title: 'Publication Failed',
          text: msg,
          confirmButtonText: 'OK',
          confirmButtonColor: '#0d6efd',
        })
      } finally {
        this.loading = false
      }
    },

    async fetchSupplierDocumentTypes() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch((process.env.VUE_APP_URL || '') + '/supplier-document-type', {
          headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
        })
        if (!res.ok) return
        const data = await res.json()
        this.supplierDocumentTypes = Array.isArray(data) ? data : (data.data || [])
        
        const mandatoryDocs = this.supplierDocumentTypes.filter(dt => dt.isMandatory);
        if (mandatoryDocs.length > 0) {
          const existingIds = this.selectedRequiredDocumentObjects.map(d => d.id);
          mandatoryDocs.forEach(md => {
            if (!existingIds.includes(md.id)) {
              this.selectedRequiredDocumentObjects.push(md);
            }
          });
        }
      } catch (err) {
        console.error('Failed to load supplier document types', err)
      }
    },

    async fetchProcessingPurchaseRequests() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'))
        const res = await fetch((process.env.VUE_APP_URL || '') + '/purchase-requests?status=PROCESSING&limit=100', { headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' } })
        if (!res.ok) return
        const data = await res.json()
        // Support multiple shapes: direct array, { data: [...] }, { data: { data: [...] } }
        let items = []
        if (Array.isArray(data)) items = data
        else if (Array.isArray(data.data)) items = data.data
        else if (data.data && Array.isArray(data.data.data)) items = data.data.data
        else items = []
        this.processingPurchaseRequests = items
      } catch (err) {
        console.error('Failed to load processing purchase requests', err)
      }
    },

    goBack() {
      this.$router.push('/admin/tenders')
    }
  }
}
</script>



<style lang="scss" scoped>

@import 'vue-multiselect/dist/vue-multiselect.min.css';

/* SCSS VARIABLES */
$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;

/* Reuse styles from HomeTransactions.vue */
.transaction {
  min-height: 100vh;
  background-color: #f8f9fa;
}

#transaction-products {
  padding: 20px 0;
}



.filter-search-body {
  padding: 24px;
}

/* Header row: title + publish button aligned horizontally */
.tender-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px !important;
  opacity: 0.9 !important;
  padding-bottom: 11px !important;
  flex-wrap: wrap;
  gap: 11px !important;
}
.tender-header-row .publish-btn {
  background: linear-gradient(90deg, #f59e0b 0%, #f1bc96 100%);
  color: #fff !important;
  padding: 11px;
  border-radius: 8px;
  font-weight: 600;
  border: none;
  box-shadow: 0 4px 11px rgba(245, 158, 11, 0.35);
  white-space: nowrap;
}
.tender-header-row .publish-btn:hover:not(:disabled) {
  box-shadow: 0 6px 16px rgba(245, 158, 11, 0.45);
}
.tender-header-row .publish-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Form Sections */
.form-section-header {
  margin: 1px 0 0px 0;
  padding-bottom: 10px;
  /*border-bottom: 2px solid #e5e7eb;*/
}

.form-section-header h6 {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

/* Highlighted style when creating from a purchase request */
.form-section-header.pr-header {
}
.form-section-header.pr-header h6 {
  color: #0d4d82;
}

/* Inputs */
input,
textarea,
select {
  border: 1px solid #b4c7e7;
  border-radius: 3px;
}

/* Constrain textarea heights for better density */
textarea.form-control {
  min-height: 48px;
  max-height: 120px;
  height: auto;
  resize: vertical;
}

/* Ensure multiselects use full width */
.multiselect, .vue-multiselect {
  width: 100% !important;
}
.multiselect .multiselect__tags, .vue-multiselect .multiselect__tags {
  width: 100% !important;
}

/* Make multiselect tags use brand orange rather than green */
:deep(.multiselect__tag) {
  background: linear-gradient(90deg, #2B286C 0%, #2B286C 100%) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 6px 10px !important;
  box-shadow: 0 6px 18px rgba(15,23,42,0.06) !important;
}

:deep(.multiselect__tag .multiselect__tag__remove) {
  color: rgba(255,255,255,0.95) !important;
}

:deep(.multiselect--open .multiselect__content) {
  z-index: 2200; /* ensure dropdown sits above floating publish bar */
}

::placeholder {
  color: black !important;
  opacity: .7 !important;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

.btn-primary {
  background: #3b82f6;
  color: white;
}

.btn-secondary {
  background: #6b7280;
  color: white;
}

.btn-warning {
  background: #f59e0b;
  color: white;
}

/* Show All Prequalified Suppliers: hover styling is the default */
.btn-supplier-toggle {
  font-weight: 600;
  text-decoration: underline;
  background: #f1f3f5;
  border: 1px solid #dee2e6;
  color: #495057;
}
.btn-supplier-toggle:hover {
  background: #f1f3f5;
  border-color: #dee2e6;
  color: #495057;
}

/* Toggle Switch */
.check-button {
  display: flex;
  align-items: center;
  gap: 10px;
}

.components-button {
  span.switcher {
    position: relative;
    width: 156px;
    height: 56px;

    input {
      appearance: none;
      width: 130px;
      height: 40px;
      background: $primary;
      border-radius: 3px;

      &:checked + label {
        background: $green;
        left: 4px;
      }
    }

    label {
      position: absolute;
      width: 55px;
      height: 32px;
      top: 4px;
      left: 100px;
      background: $green;
      border-radius: 3px;
      transition: all .3s;
    }
  }
}

/* Responsive */
@media (max-width: 768px) {
  .btn {
    width: 100%;
  }
}

/* Floating publish button on right side */
.floating-publish {
  position: fixed;
  right: 24px;
  top: 120px;
  z-index: 1200;
}
.floating-publish .btn {
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  padding: 11px 18px;
  border-radius: 8px;
}

.floating-publish .btn.publish-btn {
  background: linear-gradient(90deg, #f59e0b 0%, #f97316 100%);
  color: #fff;
  padding: 13px 22px;
  border-radius: 11px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  box-shadow: 0 13px 36px rgba(15,23,42,0.18);
  transition: transform .12s ease, box-shadow .12s ease, opacity .12s ease;
}
.floating-publish .btn.publish-btn:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 18px 44px rgba(15,23,42,0.22);
}
.floating-publish .btn.publish-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* On small screens show a bottom-fixed prominent bar */
@media (max-width: 992px) {
  .floating-publish {
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    display: flex;
    justify-content: center;
    padding: 11px 16px;
    background: rgba(255,255,255,0.96);
    box-shadow: 0 -8px 18px rgba(15,23,42,0.06);
  }
  .floating-publish .btn.publish-btn {
    width: calc(100% - 48px);
    max-width: 640px;
    padding: 13px 18px;
    border-radius: 10px;
    font-size: 16px;
  }
}

/* hide on small screens where it would overlap content */
@media (max-width: 992px) {
  .floating-publish { display: none; }
}

/* Page loading: blur and disable */
.add-tender-page {
  position: relative;
  min-height: 200px;
}

.add-tender-content {
  transition: filter 0.4s ease-out, opacity 0.4s ease-out;
}

.add-tender-content--loading {
  filter: blur(5px);
  opacity: 0.7;
  pointer-events: none;
  user-select: none;
}

</style>
